import React, { useEffect, useMemo, useState } from "react";
import { Container, Form, Button, Table, Modal, Dropdown } from "react-bootstrap";
import Swal from "sweetalert2";

import {API_BASE} from "../../services/apirest";

const FormularioUsuarios = () => {
  // ======= Catálogos / plazas =======
  const [regiones, setRegiones] = useState([]);
  const [plazaSearch, setPlazaSearch] = useState("");
  const [showPlazaDropdown, setShowPlazaDropdown] = useState(false);

  // ======= Catálogo distribuidores (dinámico) =======
  const [distList, setDistList] = useState([]); // [{id, nombre}]
  const [distSearch, setDistSearch] = useState("");
  const [showDistDropdown, setShowDistDropdown] = useState(false);

  // ======= Validaciones / flags =======
  const [errors, setErrors] = useState({ rfc: "" });
  const [isRFCDuplicate, setIsRFCDuplicate] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [isBlacklisted, setIsBlacklisted] = useState(false);
  const [showBlacklistModal, setShowBlacklistModal] = useState(false);

  // NUEVO: labels de respaldo para los toggles
  const [uiPlazaLabel, setUiPlazaLabel] = useState("");
  const [uiDistLabel, setUiDistLabel] = useState("");

  const validarRFCsinHomoclave = (rfc) => /^[A-ZÑ&]{3,4}\d{6}$/i.test(rfc);

  // ======= Carga robusta de plazas (region.php) =======
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/region.php`);
        const raw = await res.text();
        let data;
        try { data = JSON.parse(raw); } catch { data = { status: "error", result: { error_msg: raw } }; }
        if (data?.status !== "success" && typeof data?.result?.error_msg === "string") {
          try {
            const inside = JSON.parse(data.result.error_msg);
            if (inside?.status === "success") data = inside;
          } catch {}
        }
        let list = [];
        if (data?.status === "success" && data?.result) {
          if (Array.isArray(data.result.region)) list = data.result.region;
          else if (Array.isArray(data.result.regiones)) list = data.result.regiones;
          else {
            const k = Object.keys(data.result).find((key) => Array.isArray(data.result[key]));
            list = k ? data.result[k] : [];
          }
        }
        const norm = (list || [])
            .map((r) => ({ id: r.id ?? r.ID ?? r.Id, plaza: r.plaza ?? r.PLAZA ?? r.Plaza }))
            .filter((r) => r.id != null && (r.plaza ?? "") !== "");
        setRegiones(norm);
        if (!norm.length) console.warn("region.php sin plazas. Respuesta cruda:", raw);
      } catch (e) {
        console.error("Error cargando region.php:", e);
        setRegiones([]);
      }
    })();
  }, []);

  const sortedPlazas = useMemo(
      () => regiones.slice().sort((a, b) => (a.plaza || "").localeCompare(b.plaza || "")),
      [regiones]
  );

  // ======= Carga distribuidores dinámicos (distribuidores.php) =======
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/distribuidores.php`, { method: "GET" });
        const raw = await res.text();

        let data;
        try { data = JSON.parse(raw); }
        catch {
          console.warn("distribuidores.php respondió texto no-JSON:", raw);
          setDistList([]);
          return;
        }

        if (data?.status !== "success" && typeof data?.result?.error_msg === "string") {
          try {
            const inside = JSON.parse(data.result.error_msg);
            if (inside?.status === "success") data = inside;
          } catch {}
        }

        let list = [];
        if (Array.isArray(data?.result?.distribuidores)) list = data.result.distribuidores;
        else if (Array.isArray(data?.distribuidores)) list = data.distribuidores;
        else if (Array.isArray(data?.result)) list = data.result;
        else if (Array.isArray(data)) list = data;
        else {
          const k = data?.result ? Object.keys(data.result).find((key) => Array.isArray(data.result[key])) : null;
          if (k) list = data.result[k];
        }

        const norm = (list || [])
            .map((d) => ({
              id: d.id_distribuidor ?? d.id ?? d.ID ?? d.Id ?? null,
              nombre: d.distribuidores ?? d.nombre ?? d.NOMBRE ?? d.Nombre ?? "",
            }))
            .filter((d) => d.id != null && d.nombre !== "");

        if (!norm.length) {
          console.warn("distribuidores.php sin datos o llaves inesperadas. Respuesta cruda:", raw);
        }
        setDistList(norm);
      } catch (e) {
        console.error("Error cargando distribuidores:", e);
        setDistList([]);
      }
    })();
  }, []);

  const sortedDistribuidores = useMemo(
      () => distList.slice().sort((a, b) => (a.nombre || "").localeCompare(b.nombre || "")),
      [distList]
  );

  // ======= Roles =======
  const roles = [
    { id: 1, nombre: "Administrador del sistema" },
    { id: 14, nombre: "Analista" },
    { id: 13, nombre: "Marketing" },
    { id: 2, nombre: "Gerente" },
    { id: 3, nombre: "Supervisor interno" },
    { id: 4, nombre: "Distribuidor" },
    { id: 12, nombre: "Gerente Externo" },
  ];

  // ======= Datos / tabla =======
  const [usuarios, setUsuarios] = useState([]);

  // ======= Forms =======
  const [formData, setFormData] = useState({
    UsuarioId: null,
    nombre_usuario: "",
    apellido_paterno: "",
    apellido_materno: "",
    rfc: "",
    telefono: "",
    numero_vendedor: "",
    correo_izzi: "",
    usuario: "",
    password: "",
    rol_id: "",
    Estado: "Activo",
    distribuidor_id: "",
    region_id: "",
    gerente_id: null,
  });

  const [distForm, setDistForm] = useState({
    distribuidores: "",
    razon_social: "",
    kam: "",
    correo_kam: "",
    correo_supervisor: "",
    telefono: "",
    password: "",
  });

  const [modalVisible, setModalVisible] = useState(false);

  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/perfil.php`, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
      .then(r => r.json())
      .then(d => { if (d.status === "success") setCurrentUser(d.result.user); })
      .catch(() => {});
  }, []);

  // ======= Auth headers =======
  const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  // Helpers visibilidad por rol
  const rol = Number(formData.rol_id);
  const showPlaza = !!rol && rol !== 4;
  const isDistribuidor = rol === 4;

  // Helpers de respuesta tolerantes
  const parseMaybeJson = async (res) => {
    const ct = (res.headers.get("content-type") || "").toLowerCase();
    try {
      if (ct.includes("application/json")) {
        return await res.json();
      }
      // algunos back devuelven JSON con content-type/texto
      const txt = await res.text();
      try { return JSON.parse(txt); } catch { return { raw: txt }; }
    } catch {
      return null;
    }
  };

  const hasExplicitError = (data) => {
    if (!data || typeof data !== "object") return false;
    const status = (data.status || data?.result?.status || "").toString().toLowerCase();
    if (["error", "fail", "failed"].includes(status)) return true;
    // si hay un error_msg notorio
    if (data?.result?.error_msg && typeof data.result.error_msg === "string") return true;
    return false;
  };

  const isBackendSuccess = (res, data) => {
    if (!res.ok) return false;
    // si el server dijo explícitamente error, respeta eso
    if (hasExplicitError(data)) return false;

    // señales positivas comunes (tolerantes a typos)
    const status = (data?.status || data?.result?.status || "").toString().toLowerCase();
    if (["ok", "success", "succces", "succues"].includes(status)) return true;

    // si devolvió un array u objeto sin "status" claro, pero el HTTP fue 2xx ⇒ considéralo éxito
    if (Array.isArray(data)) return true;
    if (data && typeof data === "object" && Object.keys(data).length === 0) return true;

    // si trae id/insert_id/result “normal”
    if (data?.result?.id || data?.result?.insert_id || data?.id || data?.insert_id) return true;

    // último fallback: si res.ok y no hay señales de error → éxito
    return true;
  };

  // ======= RFC: duplicados =======
  const checkDuplicate = async (field, value) => {
    const val = (value || "").trim();
    if (!val) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
      if (field === "rfc") setIsRFCDuplicate(false);
      return;
    }
    try {
      const resChk = await fetch(`${API_BASE}/checkRegistro.php?campo=${field}&valor=${encodeURIComponent(val)}`);
      const chk = await resChk.json();

      if (field === "rfc") {
        if (chk.status === "ok" && Array.isArray(chk.result) && chk.result[0]?.status === "Activo") {
          setIsRFCDuplicate(true);
          setShowDetailModal(true);
          setErrors((prev) => ({ ...prev, rfc: "" }));
          return;
        }
        setIsRFCDuplicate(false);
      }

      setErrors((prev) => ({
        ...prev,
        [field]: chk.status !== "ok" && chk.result?.error_msg ? chk.result.error_msg : "",
      }));
    } catch (err) {
      console.error("Error en checkDuplicate:", err);
    }
  };

  // ======= Blacklist por nombre completo =======
  const checkBlacklistByName = async () => {
    const fullName = `${formData.nombre_usuario} ${formData.apellido_paterno} ${formData.apellido_materno}`.trim();
    if (!fullName) return;
    try {
      const res = await fetch(`${API_BASE}/blackList.php?nombre=${encodeURIComponent(fullName)}`);
      const data = await res.json();
      if (data.status === "ok" && Array.isArray(data.result) && data.result.length > 0) {
        setIsBlacklisted(true);
        setShowBlacklistModal(true);
      } else {
        setIsBlacklisted(false);
      }
    } catch (err) {
      console.error("Error buscando en blacklist:", err);
      setIsBlacklisted(false);
    }
  };

   // ======= CRUD =======
  const obtenerUsuarios = async () => {
    try {
      const res = await fetch(`${API_BASE}/usuarios.php`, { method: "GET", headers });
      const data = await res.json();
      if (res.status === 401) {
        await Swal.fire("Sin permisos", data?.result?.error_msg || "No autorizado", "warning");
        return;
      }
      if (res.ok && (data.status === "success" || data.status === "ok")) {
        const raw = data.result?.usuarios ?? [];
        const norm = raw.map((u) => ({
          ...u,
          rfc: u.rfc ?? u.RFC ?? "",
          telefono: u.telefono ?? u.Telefono ?? "",
        }));
        setUsuarios(norm);
      } else {
        await Swal.fire("Error", data?.result?.error_msg || "No se pudo obtener usuarios", "error");
      }
    } catch (err) {
      console.error("Error al obtener usuarios:", err);
      await Swal.fire("Error", "Problema al conectar al servidor", "error");
    }
  };

  const handleGuardar = async () => {
    // === Flujo DISTRIBUIDOR ===
    if (isDistribuidor) {
      const faltantesD = [];
      if (!distForm.distribuidores) faltantesD.push("Nombre de distribuidor");
      if (!distForm.razon_social)  faltantesD.push("Razón social");
      if (!distForm.kam)           faltantesD.push("KAM");
      if (!distForm.correo_kam)    faltantesD.push("Correo KAM");
      if (!distForm.telefono)      faltantesD.push("Teléfono");

      const telClean = (distForm.telefono || "").replace(/\D/g, "");
      if (telClean.length !== 10) {
        await Swal.fire("Teléfono inválido", "El teléfono del distribuidor debe tener 10 dígitos.", "warning");
        return;
      }

      if (faltantesD.length) {
        await Swal.fire("Campos requeridos", `Completa: ${faltantesD.join(", ")}`, "warning");
        return;
      }

      const nombreDist = distForm.distribuidores.trim().toUpperCase();
      const isEdit = !!formData.UsuarioId;
      const distId = Number(formData.distribuidor_id) || null;

      try {
        // 1) EDITAR: UPDATE distribuidor + UPDATE usuario
        if (isEdit && distId) {
          const resDistUpd = await fetch(`${API_BASE}/distribuidores.php`, {
            method: "PUT",
            headers,
            body: JSON.stringify({
              id_distribuidor: distId,
              distribuidores: nombreDist,
              razon_social:   distForm.razon_social.trim().toUpperCase(),
              kam:            distForm.kam.trim().toUpperCase(),
              correo_kam:     distForm.correo_kam.trim(),
              correo_supervisor: distForm.correo_supervisor?.trim() || null,
            }),
          });
          const dataDistUpd = await parseMaybeJson(resDistUpd);

          if (resDistUpd.status === 401) {
            setModalVisible(false);
            await Swal.fire("Sin permisos", dataDistUpd?.result?.error_msg || "No autorizado", "warning");
            return;
          }
          if (!isBackendSuccess(resDistUpd, dataDistUpd)) {
            setModalVisible(false);
            await Swal.fire("Error", dataDistUpd?.result?.error_msg || "No se pudo actualizar el distribuidor", "error");
            return;
          }

          const hoy = new Date().toISOString().slice(0, 10);
          const payloadUsuarioUpd = {
            UsuarioId: formData.UsuarioId,
            Usuario: nombreDist,
            nombre_usuario: nombreDist,
            apellido_paterno: "",
            apellido_materno: "",
            rfc: "",
            telefono: telClean,
            numero_vendedor: formData.numero_vendedor || "",
            usuario: nombreDist,
            rol_id: 4,
            Estado: formData.Estado || "Activo",
            distribuidor_id: distId,
            region_id: null,
            gerente_id: null,
            fecha: hoy,
            password: distForm.password || null,
            correo_izzi: null,
            usuario_red: null,
            contraseña_red: null,
            foto_id: null,
            ine_id: null,
            uso_clave_id: null,
          };

          const resUserUpd = await fetch(`${API_BASE}/usuarios.php`, {
            method: "PUT",
            headers,
            body: JSON.stringify(payloadUsuarioUpd),
          });
          const dataUserUpd = await parseMaybeJson(resUserUpd);

          setModalVisible(false);

          if (resUserUpd.status === 401) {
            await Swal.fire("Sin permisos", dataUserUpd?.result?.error_msg || "No autorizado", "warning");
            return;
          }
          if (isBackendSuccess(resUserUpd, dataUserUpd)) {
            await Swal.fire("Éxito", "Distribuidor y usuario actualizados", "success");
            obtenerUsuarios();
          } else {
            await Swal.fire("Error", dataUserUpd?.result?.error_msg || "No se pudo actualizar el usuario", "error");
          }
          return;
        }

        // 2) CREAR: POST distribuidor + POST usuario sombra
        const resDist = await fetch(`${API_BASE}/distribuidores.php`, {
          method: "POST",
          headers,
          body: JSON.stringify({
            distribuidores: nombreDist,
            razon_social:   distForm.razon_social.trim().toUpperCase(),
            kam:            distForm.kam.trim().toUpperCase(),
            correo_kam:     distForm.correo_kam.trim(),
            correo_supervisor: distForm.correo_supervisor?.trim() || null,
            telefono:       telClean,
          }),
        });
        const dataDist = await parseMaybeJson(resDist);

        if (resDist.status === 401) {
          setModalVisible(false);
          await Swal.fire("Sin permisos", dataDist?.result?.error_msg || "No autorizado", "warning");
          return;
        }
        if (!isBackendSuccess(resDist, dataDist)) {
          setModalVisible(false);
          await Swal.fire("Error", dataDist?.result?.error_msg || "No se pudo guardar el distribuidor", "error");
          return;
        }

        const nuevoDistribuidorId =
            dataDist?.result?.id_distribuidor ?? dataDist?.result?.id ?? dataDist?.result?.insert_id ?? dataDist?.id ?? dataDist?.insert_id;
        if (!nuevoDistribuidorId) {
          setModalVisible(false);
          await Swal.fire("Error", "No fue posible determinar el ID del distribuidor creado", "error");
          return;
        }

        const hoy = new Date().toISOString().slice(0, 10);
        const usuarioPayload = {
          Usuario: nombreDist,
          nombre_usuario: nombreDist,
          apellido_paterno: "",
          apellido_materno: "",
          rfc: "",
          usuario: nombreDist,
          password: distForm.password || "1234",
          must_change_password: true,
          rol_id: 4,
          Estado: "Activo",
          distribuidor_id: Number(nuevoDistribuidorId),
          region_id: null,
          gerente_id: null,
          fecha: hoy,
          telefono: telClean,
          correo_izzi: null,
          usuario_red: null,
          contraseña_red: null,
          foto_id: null,
          ine_id: null,
          uso_clave_id: null,
          numero_vendedor: formData.numero_vendedor || "",
        };

        const resUser = await fetch(`${API_BASE}/usuarios.php`, {
          method: "POST",
          headers,
          body: JSON.stringify(usuarioPayload),
        });
        const dataUser = await parseMaybeJson(resUser);

        setModalVisible(false);

        if (resUser.status === 401) {
          await Swal.fire("Sin permisos", dataUser?.result?.error_msg || "No autorizado", "warning");
          return;
        }

        if (isBackendSuccess(resUser, dataUser)) {
          await Swal.fire("Éxito", "Distribuidor y usuario creados", "success");
          obtenerUsuarios();
        } else {
          await Swal.fire(
              "Atención",
              "El distribuidor se creó, pero no se pudo crear el usuario asociado.\n" +
              (dataUser?.result?.error_msg || ""),
              "warning"
          );
        }
      } catch (err) {
        console.error("Error al guardar distribuidor/usuario:", err);
        setModalVisible(false);
        await Swal.fire("Error", "Problema al conectar al servidor", "error");
      }
      return; // Termina flujo distribuidor
    }

    // === Flujo USUARIO (no distribuidor) ===
    const isEdit = !!formData.UsuarioId;
    const method = isEdit ? "PUT" : "POST";
    const hoy = new Date().toISOString().slice(0, 10);
    const USUARIO_DERIVADO = `${(formData.nombre_usuario || "").toUpperCase()} ${(formData.apellido_paterno || "").toUpperCase()}`.trim();
    const usuarioCol = isEdit
        ? (formData.usuario || formData.Usuario || USUARIO_DERIVADO)
        : USUARIO_DERIVADO;

    const correoIzzi = (formData.correo_izzi || "").trim() || null;

    const payload = {
      UsuarioId: formData.UsuarioId ?? null,

      Usuario: usuarioCol,
      nombre_usuario: (formData.nombre_usuario || "").toUpperCase(),
      apellido_paterno: (formData.apellido_paterno || "").toUpperCase(),
      apellido_materno: (formData.apellido_materno || "").toUpperCase(),

      rfc: (formData.rfc || "").toUpperCase(),
      telefono: formData.telefono || "",
      numero_vendedor: formData.numero_vendedor || "",

      usuario: formData.usuario || "",
      rol_id: Number(formData.rol_id) || null,
      Estado: formData.Estado || "Activo",

      distribuidor_id: Number(formData.distribuidor_id),
      region_id: showPlaza && formData.region_id ? Number(formData.region_id) : null,

      gerente_id: formData.gerente_id ?? null,
      fecha: hoy,

      correo_izzi: correoIzzi,
      usuario_red: null,
      contraseña_red: null,
      foto_id: null,
      ine_id: null,
      uso_clave_id: null,
    };

    if (!isEdit) {
      payload.password = formData.password || "1234";
      payload.must_change_password = true;
    } else if (formData.password) {
      // Si estamos editando y se escribió una contraseña nueva
      payload.password = formData.password;
    }

    if (!isEdit) {
      const faltantes = [];
      if (!payload.nombre_usuario) faltantes.push("Nombre");
      if (!payload.apellido_paterno) faltantes.push("Apellido Paterno");
      if (!payload.apellido_materno) faltantes.push("Apellido Materno");
      if (!payload.rfc) faltantes.push("RFC");
      if (!validarRFCsinHomoclave(payload.rfc)) faltantes.push("RFC con formato válido");
      if (!payload.telefono) faltantes.push("Teléfono");
      if (!payload.numero_vendedor) faltantes.push("Número Vendedor");
      if (!payload.rol_id) faltantes.push("Rol");
      if (!payload.distribuidor_id) faltantes.push("Distribuidor");
      if (showPlaza && !payload.region_id) faltantes.push("Plaza");

      if (faltantes.length) {
        return Swal.fire("Campos requeridos", `Completa: ${faltantes.join(", ")}`, "warning");
      }
      if (isRFCDuplicate) {
        return Swal.fire("RFC duplicado", "El RFC ya se encuentra activo. Revisa con tu supervisor.", "warning");
      }
      if (isBlacklisted) {
        return Swal.fire("Acceso denegado", "El asesor está en lista negra.", "error");
      }
    }

    try {
      const res = await fetch(`${API_BASE}/usuarios.php`, {
        method,
        headers,
        body: JSON.stringify(payload),
      });
      const data = await parseMaybeJson(res);

      if (res.status === 401) {
        setModalVisible(false);
        await Swal.fire("Sin permisos", data?.result?.error_msg || "No autorizado", "warning");
        return;
      }

      setModalVisible(false);

      if (isBackendSuccess(res, data)) {
        await Swal.fire(
            "Éxito",
            formData.UsuarioId ? "Usuario actualizado" : "Usuario creado",
            "success"
        );
        obtenerUsuarios();
      } else {
        await Swal.fire("Error", data?.result?.error_msg || "No se pudo guardar el usuario", "error");
        console.warn("Payload enviado:", payload);
        console.warn("Respuesta backend:", data);
      }
    } catch (err) {
      console.error("Error al guardar usuario:", err);
      setModalVisible(false);
      await Swal.fire("Error", "Problema al conectar al servidor", "error");
    }
  };
// === Editar ===
  const handleEditar = async (u) => {
    const rolN     = Number(u.rol_id ?? u.id_rol ?? u.RolId ?? 0);

    const distId   = u.distribuidor_id  ?? u.id_distribuidor  ?? u.DistribuidorId  ?? u.distribuidor  ?? "";
    const distNom  = u.distribuidor_nombre ?? u.nombre_distribuidor ?? u.Distribuidor ?? u.distribuidores ?? "";

    const plazaNom = u.plaza ?? u.plaza_nombre ?? u.Region ?? u.nombre_region ?? "";

    const telefono = u.telefono ?? u.Telefono ?? "";   // ← SIEMPRE de usuarios
    const usuario  = u.Usuario ?? u.usuario ?? "";

    setFormData({
      UsuarioId: u.UsuarioId ?? null,
      nombre_usuario: u.nombre_usuario || "",
      apellido_paterno: u.apellido_paterno || "",
      apellido_materno: u.apellido_materno || "",
      rfc: u.rfc || "",
      telefono: u.telefono || "",
      numero_vendedor: u.numero_vendedor || "",
      correo_izzi: u.correo_izzi || "",
      usuario: u.Usuario || "",
      password: "",
      rol_id: rolN,
      Estado: u.Estado || "Activo",
      distribuidor_id: u.distribuidor_id || "",
      region_id: u.region_id || "",
      gerente_id: u.gerente_id ?? null,
    });


    // Labels de respaldo para los toggles (mientras cargan listas)
    setUiDistLabel(distNom ? String(distNom).toUpperCase() : "");
    setUiPlazaLabel(plazaNom ? String(plazaNom).toUpperCase() : "");

    if (rolN === 4 && distId) {
      try {
        const res = await fetch(`${API_BASE}/distribuidores.php?id_distribuidor=${encodeURIComponent(distId)}`);
        const raw = await res.text();
        let data; try { data = JSON.parse(raw); } catch { data = null; }
        const item =
            data?.result?.distribuidores?.[0] ??
            data?.result?.[0] ??
            data?.distribuidores?.[0] ??
            data?.[0] ?? null;

        setDistForm({
          distribuidores: (item?.distribuidores || usuario || "").toString().toUpperCase(),
          razon_social:   (item?.razon_social   || "").toString().toUpperCase(),
          kam:            (item?.kam            || "").toString().toUpperCase(),
          correo_kam:       item?.correo_kam        || "",
          correo_supervisor:item?.correo_supervisor || "",
          telefono:       (telefono || "").toString(), // ← siempre desde usuarios
          password: "",
        });

        if (item?.distribuidores) setUiDistLabel(String(item.distribuidores).toUpperCase());
      } catch {
        setDistForm({
          distribuidores: (usuario || "").toString().toUpperCase(),
          razon_social: "",
          kam: "",
          correo_kam: "",
          correo_supervisor: "",
          telefono: (telefono || "").toString(),
        });
      }
    } else {
      setDistForm({
        distribuidores: "",
        razon_social: "",
        kam: "",
        correo_kam: "",
        correo_supervisor: "",
        telefono: "",
      });
    }

    setIsRFCDuplicate(false);
    setIsBlacklisted(false);
    setErrors({ rfc: "" });
    setModalVisible(true);
  };

  // === Nuevo / Cerrar ===
  const initialForm = {
    UsuarioId: null,
    nombre_usuario: "",
    apellido_paterno: "",
    apellido_materno: "",
    correo_izzi: "",
    rfc: "",
    telefono: "",
    numero_vendedor: "",
    usuario: "",
    password: "",
    rol_id: "",
    Estado: "Activo",
    distribuidor_id: "",
    region_id: "",
    gerente_id: null,
  };

  const handleNuevo = () => {
    setFormData(initialForm);
    setDistForm({ distribuidores: "", razon_social: "", kam: "", correo_kam: "", correo_supervisor: "", telefono: "", password: "" });
    setIsRFCDuplicate(false);
    setIsBlacklisted(false);
    setErrors({ rfc: "" });
    setModalVisible(true);
  };

  const handleClose = () => {
    setModalVisible(false);
    setFormData(initialForm);
    setDistForm({ distribuidores: "", razon_social: "", kam: "", correo_kam: "", correo_supervisor: "", telefono: "", password: "" });
    setIsRFCDuplicate(false);
    setIsBlacklisted(false);
    setErrors({ rfc: "" });
  };

  useEffect(() => {
    obtenerUsuarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // === Eliminar (usuario y lógica especial para rol 3 y 4) ===
  const handleEliminar = async (u) => {
    const UsuarioId = u.UsuarioId ?? u.id ?? u.ID;
    const rolN = Number(u.rol_id ?? u.id_rol ?? 0);
    const distId = u.distribuidor_id ?? u.id_distribuidor ?? null;

    if (!UsuarioId) {
      await Swal.fire("Error", "Falta UsuarioId", "error");
      return;
    }

    const isDistribuidor = rolN === 4 && distId;
    const isSupervisor  = rolN === 3;

    const confirm = await Swal.fire({
      title: isDistribuidor ? "¿Eliminar distribuidor?" : "¿Eliminar usuario?",
      text: isDistribuidor
          ? "Se inactivará el usuario y se eliminará el registro del distribuidor."
          : (isSupervisor
              ? "Se inactivará el usuario. Los gerentes asignados quedarán sin supervisor."
              : "Se cambiará inactivará estado del usuario."),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
    });
    if (!confirm.isConfirmed) return;

    try {
      // 1) Inactivar usuario
      const resUser = await fetch(`${API_BASE}/usuarios.php`, {
        method: "DELETE",
        headers,
        body: JSON.stringify({ UsuarioId }),
      });
      const userJson = await resUser.json().catch(() => ({}));
      if (!(resUser.ok && (userJson.status === "success" || userJson.status === "ok"))) {
        await Swal.fire("Error", userJson?.result?.error_msg || "No se pudo eliminar el usuario", "error");
        return;
      }

      // 2) Si es distribuidor, eliminar también el distribuidor
      if (isDistribuidor) {
        const resDist = await fetch(`${API_BASE}/distribuidores.php`, {
          method: "DELETE",
          headers,
          body: JSON.stringify({ id_distribuidor: Number(distId) }),
        });
        const distJson = await resDist.json().catch(() => ({}));
        if (!(resDist.ok && (distJson.status === "success" || distJson.status === "ok"))) {
          await Swal.fire(
              "Atención",
              "Usuario inactivado, pero no se pudo eliminar el distribuidor.",
              "warning"
          );
        }
      }

      // 3) Si es SUPERVISOR, actualizar Gerentes: VACANTE (PLAZA)
      if (isSupervisor) {
        // helper para plaza en MAYÚSCULAS desde catálogo local
        const getPlazaUpper = (plaza_id) => {
          const match = regiones.find(r => String(r.id) === String(plaza_id));
          return (match?.plaza ? String(match.plaza) : "PLAZA").toUpperCase();
        };

        // 3.1 intentar GET filtrado; si el backend no filtra, traer todo y filtrar aquí
        const resG = await fetch(`${API_BASE}/gerentes.php?supervisor_usuario_id=${encodeURIComponent(UsuarioId)}`, {
          method: "GET",
          headers,
        });
        const rawG = await resG.text();
        let gData; try { gData = JSON.parse(rawG); } catch { gData = null; }

        // normaliza respuesta
        let gerentes = Array.isArray(gData?.result?.gerentes)
            ? gData.result.gerentes
            : Array.isArray(gData?.result)
                ? gData.result
                : Array.isArray(gData)
                    ? gData
                    : [];

        // si el endpoint ignoró el filtro, filtramos en front
        if (!gerentes.length && Array.isArray(gData?.todos)) gerentes = gData.todos; // por si tienes otra llave
        if (gerentes.length && gerentes.some(g => g.supervisor_usuario_id === undefined)) {
          // parece que devolvió todo sin filtrar: intenta GET "plano" (sin query) y filtra
          try {
            const resAll = await fetch(`${API_BASE}/gerentes.php`, { method: "GET", headers });
            const rawAll = await resAll.text();
            let all; try { all = JSON.parse(rawAll); } catch { all = null; }
            gerentes = Array.isArray(all?.result?.gerentes)
                ? all.result.gerentes
                : Array.isArray(all?.result)
                    ? all.result
                    : Array.isArray(all)
                        ? all
                        : [];
          } catch {}
        }
        // filtra por supervisor_usuario_id
        gerentes = gerentes.filter(g => String(g.supervisor_usuario_id) === String(UsuarioId));

        if (gerentes.length) {
          // 3.2 construir y disparar updates
          const updates = gerentes.map(async (g) => {
            const id_gerente = g.id_gerente ?? g.gerente_id ?? g.id;
            const plaza_id   = g.plaza_id ?? g.region_id; // tu tabla es plaza_id
            const vacante    = `VACANTE (${getPlazaUpper(plaza_id)})`;

            // 1er intento con NULL, si el backend no acepta, reintenta con 0
            const payloadBase = {
              id_gerente,
              supervisor_interno: vacante,
              correo_supervisor:  vacante,
              supervisor_usuario_id: null,
            };

            const r1 = await fetch(`${API_BASE}/gerentes.php`, {
              method: "PUT",
              headers,
              body: JSON.stringify(payloadBase),
            });
            const j1 = await r1.json().catch(() => ({}));
            if (r1.ok && (j1.status === "success" || j1.status === "ok")) return true;

            const r2 = await fetch(`${API_BASE}/gerentes.php`, {
              method: "PUT",
              headers,
              body: JSON.stringify({ ...payloadBase, supervisor_usuario_id: 0 }),
            });
            const j2 = await r2.json().catch(() => ({}));
            return r2.ok && (j2.status === "success" || j2.status === "ok");
          });

          const results = await Promise.all(updates);
          const fails = results.filter(ok => !ok).length;

          if (fails) {
            await Swal.fire(
                "Atención",
                `Usuario inactivado incompleto.`,
                "warning"
            );
          } else {
            await Swal.fire("¡LISTO!", "Usuario inactivado.", "success");
          }
        } else {
          await Swal.fire("Eliminado", "Usuario inactivado. No tenía plazas asignadas en Gerentes.", "success");
        }

        await obtenerUsuarios();
        return;
      }

      // 4) Mensaje final (otros roles / distribuidores)
      await Swal.fire(
          "Eliminado",
          isDistribuidor ? "Usuario inactivado y distribuidor eliminado." : "Usuario inactivado correctamente.",
          "success"
      );
      await obtenerUsuarios();
    } catch (err) {
      console.error("Error al eliminar:", err);
      await Swal.fire("Error", "Problema al conectar al servidor", "error");
    }
  };

  const handleReactivar = async (u) => {
    const UsuarioId = u.UsuarioId ?? u.id ?? u.ID;
    if (!UsuarioId) return;

    try {
      const resp = await fetch(`${API_BASE}/usuarios.php`, {
        method: "PUT",
        headers,
        body: JSON.stringify({ UsuarioId, Estado: "Activo" }),
      });
      const data = await resp.json().catch(() => ({}));
      if (resp.ok && (data.status === "success" || data.status === "ok")) {
        await Swal.fire("Reactivado", "El usuario ha sido regresado a estado Activo.", "success");
        obtenerUsuarios();
      } else {
        await Swal.fire("Error", data?.result?.error_msg || "No se pudo reactivar el usuario", "error");
      }
    } catch (err) {
      console.error("Error al reactivar:", err);
      await Swal.fire("Error", "Problema al conectar al servidor", "error");
    }
  };
// === Filtros y paginación (sin "Todos") ===
  const [statusFilter, setStatusFilter] = useState("Activo"); // "Activo" | "Inactivo"
  const [searchTerm, setSearchTerm] = useState("");
  const [pageSize, setPageSize] = useState(20);               // 10 | 20 | 50 | 100
  const [page, setPage] = useState(1);

// Lista filtrada por Estado y Búsqueda
  const filteredUsuarios = useMemo(() => {
    if (!Array.isArray(usuarios)) return [];
    
    return usuarios.filter((u) => {
      // 1) Filtro por Estado
      const matchStatus = String(u?.Estado || "").toUpperCase() === statusFilter.toUpperCase();
      
      // 2) Filtro por Búsqueda (Texto)
      const term = searchTerm.toLowerCase();
      const matchSearch = !term || (
        (u.nombre_usuario || "").toLowerCase().includes(term) ||
        (u.apellido_paterno || "").toLowerCase().includes(term) ||
        (u.apellido_materno || "").toLowerCase().includes(term) ||
        (u.Usuario || "").toLowerCase().includes(term) ||
        (u.correo_izzi || "").toLowerCase().includes(term) ||
        (u.rfc || "").toLowerCase().includes(term) ||
        (u.numero_vendedor || "").toLowerCase().includes(term)
      );

      return matchStatus && matchSearch;
    });
  }, [usuarios, statusFilter, searchTerm]);

// Paginación
  const totalPages = Math.max(1, Math.ceil(filteredUsuarios.length / pageSize));

// Si cambias el filtro o el tamaño de página, regresa a la página 1
  useEffect(() => { setPage(1); }, [statusFilter, pageSize]);

// Rango actual
  const pageStart = (page - 1) * pageSize;
  const pageEnd   = pageStart + pageSize;

// Items a renderizar en la tabla
  const pageItems = useMemo(
      () => filteredUsuarios.slice(pageStart, pageEnd),
      [filteredUsuarios, pageStart, pageEnd]
  );


  return (
      <section className="usuarios">
        {/* Forzar z-index de SweetAlert2 por encima del modal */}
        <style>{`.swal2-container { z-index: 20000 !important; }`}</style>

        <Container className="mt-5 pt-4">
          <h3 className="mb-4">Gestión de Usuarios</h3>

          <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            <Button variant="primary" onClick={handleNuevo}>
              Agregar Usuario
            </Button>

            {/* Filtro por Estado (sin "Todos") */}
            <Form.Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                style={{ maxWidth: 150 }}
                className="ms-2"
                aria-label="Filtrar por estado"
            >
              <option value="Activo">Activos</option>
              <option value="Inactivo">Inactivos</option>
            </Form.Select>

            {/* Buscador de usuario */}
            <Form.Control
                type="text"
                placeholder="Buscar (nombre, RFC, usuario...)"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ maxWidth: 300 }}
                className="ms-2"
                aria-label="Buscar usuario"
            />

            <div className="d-flex align-items-center ms-auto" style={{ gap: 8 }}>
              <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setPage(1)}
                  disabled={page === 1}
              >
                « Primero
              </Button>
              <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  disabled={page === 1}
              >
                ‹ Anterior
              </Button>

              <span className="mx-2 small text-muted">
            Página {page} de {totalPages}
          </span>

              <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
              >
                Siguiente ›
              </Button>
              <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setPage(totalPages)}
                  disabled={page === totalPages}
              >
                Última »
              </Button>
            </div>

            {/* Tamaño de página */}
            <div className="d-flex align-items-center ms-auto" style={{ gap: 8 }}>
              <span className="text-muted">Renglones por página:</span>
              <Form.Select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                  style={{ width: 110 }}
                  aria-label="Tamaño de página"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Form.Select>
            </div>
          </div>

          <Table striped bordered hover responsive>
            <thead className="table-light">
            <tr>
              <th>ID</th>
              <th>Nombre Completo</th>
              <th>Usuario</th>
              <th>Correo</th>
              <th>RFC</th>
              <th>Teléfono</th>
              <th>Rol</th>
              <th>Número Vendedor</th>
              <th className="text-center">Acciones</th>
            </tr>
            </thead>
            <tbody>
            {pageItems.length === 0 ? (
                <tr>
                  <td colSpan={9} className="text-center text-muted py-4">
                    {`Sin registros ${statusFilter.toLowerCase()}`}
                  </td>
                </tr>
            ) : (
                pageItems.map((u) => (
                    <tr key={u.UsuarioId}>
                      <td>{u.UsuarioId}</td>
                      <td>{u.nombre_usuario} {u.apellido_paterno} {u.apellido_materno}</td>
                      <td>{u.Usuario}</td>
                      <td>{u.correo_izzi}</td>
                      <td>{u.rfc}</td>
                      <td>{u.telefono}</td>
                      <td>{u.rol_nombre || u.rol_id}</td>
                      <td>{u.numero_vendedor}</td>
                      <td className="text-center">
                        <Button
                            variant="warning"
                            size="sm"
                            className="me-2"
                            onClick={() => handleEditar(u)}
                        >
                          Editar
                        </Button>
                        {u.Estado === "Inactivo" && (
                          <Button
                              variant="success"
                              size="sm"
                              className="me-2"
                              onClick={() => handleReactivar(u)}
                          >
                            Activar
                          </Button>
                        )}
                        <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleEliminar(u)}
                        >
                          Eliminar
                        </Button>
                      </td>
                    </tr>
                ))
            )}
            </tbody>
          </Table>

          {/* Paginación */}
          <div className="d-flex flex-wrap align-items-center justify-content-between mt-3">
            <div className="text-muted small">
              {filteredUsuarios.length === 0
                  ? "Sin registros"
                  : `Mostrando ${pageItems.length ? pageStart + 1 : 0}–${Math.min(pageEnd, filteredUsuarios.length)} de ${filteredUsuarios.length}`}
            </div>

            <div className="d-flex align-items-center" style={{ gap: 8 }}>
              <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setPage(1)}
                  disabled={page === 1}
              >
                « Primero
              </Button>
              <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  disabled={page === 1}
              >
                ‹ Anterior
              </Button>

              <span className="mx-2 small text-muted">
            Página {page} de {totalPages}
          </span>

              <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
              >
                Siguiente ›
              </Button>
              <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setPage(totalPages)}
                  disabled={page === totalPages}
              >
                Última »
              </Button>
            </div>
          </div>

          <Modal show={modalVisible} onHide={handleClose} size="lg" centered style={{ zIndex: 10000 }}>
            <Modal.Header closeButton>
              <Modal.Title>
                {isDistribuidor
                    ? (formData.UsuarioId ? "Editar Distribuidor" : "Nuevo Distribuidor")
                    : (formData.UsuarioId ? "Editar Usuario" : "Nuevo Usuario")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form autoComplete="off">
                {/* Selector de Rol: aquí hacemos el reset explícito al cambiar rol */}
                <Form.Group controlId="rol_id" className="mb-3">
                  <Form.Label>Rol</Form.Label>
                  <Form.Select
                      value={formData.rol_id}
                      disabled={
                        !!formData.UsuarioId &&
                        currentUser &&
                        formData.UsuarioId === (currentUser?.UsuarioId || currentUser?.usuario_id || currentUser?.id || currentUser?.user_id)
                      }
                      onChange={(e) => {
                        const newRol = Number(e.target.value);
                        setFormData((prev) => ({
                          ...prev,
                          rol_id: newRol,
                          // si cambia a distribuidor, limpias campos de usuario y selección de plaza/distribuidor
                          ...(newRol === 4
                                  ? {
                                    nombre_usuario: "",
                                    apellido_paterno: "",
                                    apellido_materno: "",
                                    rfc: "",
                                    telefono: "",
                                    numero_vendedor: "",
                                    region_id: "",
                                    distribuidor_id: "",
                                  }
                                  : {} // si cambia a no distribuidor, no tocamos aquí, solo limpiamos distForm
                          ),
                        }));
                        if (newRol !== 4) {
                          setDistForm({
                            distribuidores: "",
                            razon_social: "",
                            kam: "",
                            correo_kam: "",
                            correo_supervisor: "",
                            telefono: "",
                          });
                        }
                      }}
                      required
                  >
                    <option value="">-- Selecciona un rol --</option>
                    {roles.map((r) => (
                        <option key={r.id} value={r.id}>
                          {r.nombre}
                        </option>
                    ))}
                  </Form.Select>
                  {!!formData.UsuarioId && currentUser && formData.UsuarioId === (currentUser?.UsuarioId || currentUser?.usuario_id || currentUser?.id || currentUser?.user_id) && (
                    <Form.Text className="text-danger mt-1 d-block">
                      No puedes modificar tu propio nivel de acceso por seguridad.
                    </Form.Text>
                  )}
                </Form.Group>

                {/* === Sub-form DISTRIBUIDOR === */}
                {isDistribuidor && (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label>Nombre de distribuidor</Form.Label>
                        <Form.Control
                            type="text"
                            value={distForm.distribuidores}
                            onChange={(e) => setDistForm((p) => ({ ...p, distribuidores: e.target.value.toUpperCase() }))}
                            style={{ textTransform: "uppercase" }}
                            required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Razón social</Form.Label>
                        <Form.Control
                            type="text"
                            value={distForm.razon_social}
                            onChange={(e) => setDistForm((p) => ({ ...p, razon_social: e.target.value.toUpperCase() }))}
                            style={{ textTransform: "uppercase" }}
                            required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>KAM</Form.Label>
                        <Form.Control
                            type="text"
                            value={distForm.kam}
                            onChange={(e) => setDistForm((p) => ({ ...p, kam: e.target.value.toUpperCase() }))}
                            style={{ textTransform: "uppercase" }}
                            required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Correo KAM</Form.Label>
                        <Form.Control
                            type="email"
                            value={distForm.correo_kam}
                            onChange={(e) => setDistForm((p) => ({ ...p, correo_kam: e.target.value }))}
                            required
                        />
                      </Form.Group>

                      {/* Teléfono del distribuidor */}
                      <Form.Group className="mb-3">
                        <Form.Label>Teléfono</Form.Label>
                        <Form.Control
                            type="tel"
                            placeholder="Ej. 5512345678"
                            value={distForm.telefono}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              if (value.length <= 10) {
                                setDistForm((prev) => ({ ...prev, telefono: value }));
                              }
                            }}
                            required
                        />
                        <Form.Text className="text-muted">Solo 10 dígitos sin espacios ni guiones.</Form.Text>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Correo supervisor (opcional)</Form.Label>
                        <Form.Control
                            type="email"
                            value={distForm.correo_supervisor}
                            onChange={(e) => setDistForm((p) => ({ ...p, correo_supervisor: e.target.value }))}
                        />
                      </Form.Group>

                      {/* Contraseña para Distribuidor */}
                      <Form.Group className="mb-3">
                        <Form.Label>Contraseña</Form.Label>
                        <Form.Control
                            type="text"
                            value={distForm.password || ""}
                            onChange={(e) => setDistForm((p) => ({ ...p, password: e.target.value }))}
                            placeholder={formData.UsuarioId ? "Deja en blanco para no cambiar..." : "Por defecto: 1234"}
                        />
                        <Form.Text className="text-muted">
                          {formData.UsuarioId
                              ? "Escribe una nueva contraseña sólo si deseas cambiarla."
                              : "Si dejas este campo en blanco, la contraseña inicial será '1234'."}
                        </Form.Text>
                      </Form.Group>
                    </>
                )}

                {/* === Sub-form USUARIO === */}
                {!isDistribuidor && (
                    <>
                      <Form.Group controlId="nombre_usuario" className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.nombre_usuario}
                            onChange={(e) => setFormData({ ...formData, nombre_usuario: e.target.value.toUpperCase() })}
                            style={{ textTransform: "uppercase" }}
                            required
                        />
                      </Form.Group>

                      <Form.Group controlId="apellido_paterno" className="mb-3">
                        <Form.Label>Apellido Paterno</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.apellido_paterno}
                            onChange={(e) => setFormData({ ...formData, apellido_paterno: e.target.value.toUpperCase() })}
                            style={{ textTransform: "uppercase" }}
                            required
                        />
                      </Form.Group>

                      <Form.Group controlId="apellido_materno" className="mb-3">
                        <Form.Label>Apellido Materno</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.apellido_materno}
                            onChange={(e) => setFormData({ ...formData, apellido_materno: e.target.value.toUpperCase() })}
                            onBlur={checkBlacklistByName}
                            style={{ textTransform: "uppercase" }}
                            required
                        />
                      </Form.Group>
                        {/* Usuario (nombre de acceso) - visible sólo en edición */}
                      {formData.UsuarioId && (
                        <Form.Group controlId="usuario_acceso" className="mb-3">
                          <Form.Label>Usuario (nombre de acceso)</Form.Label>
                          <Form.Control
                            type="text"
                            value={formData.usuario || ""}
                            onChange={(e) => setFormData({ ...formData, usuario: e.target.value.toUpperCase() })}
                            style={{ textTransform: "uppercase" }}
                            placeholder="Se deriva de Nombre + Apellido Paterno"
                          />
                          <Form.Text className="text-muted">
                            Nombre con el que aparece en el sistema. Por defecto es NOMBRE APELLIDO_PATERNO.
                          </Form.Text>
                        </Form.Group>
                      )}

                        {/* Contraseña */}
                        <Form.Group controlId="password" className="mb-3">
                          <Form.Label>Contraseña</Form.Label>
                          <Form.Control
                            type="text"
                            value={formData.password || ""}
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                            placeholder={formData.UsuarioId ? "Deja en blanco para no cambiar..." : "Por defecto: 1234"}
                          />
                          <Form.Text className="text-muted">
                            {formData.UsuarioId 
                              ? "Escribe una nueva contraseña sólo si deseas cambiarla."
                              : "Si dejas este campo en blanco, la contraseña inicial será '1234'."}
                          </Form.Text>
                        </Form.Group>

                        {/* Correo IZZI */}
                      <Form.Group controlId="correo_izzi" className="mb-3">
                             <Form.Label>Correo izzi</Form.Label>
                             <Form.Control
                               type="email"
                               value={formData.correo_izzi}
                               onChange={(e) => setFormData({ ...formData, correo_izzi: e.target.value.trim() })}
                             />
                           </Form.Group>

                      {/* RFC */}
                      <Form.Group className="mb-3">
                        <Form.Label>RFC (SIN HOMOCLAVE)</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ej. ABCM900101"
                            value={formData.rfc}
                            onChange={(e) => {
                              const value = e.target.value.toUpperCase();
                              setFormData((prev) => ({ ...prev, rfc: value }));
                              if (value && !validarRFCsinHomoclave(value)) {
                                setErrors((prev) => ({
                                  ...prev,
                                  rfc: "Formato incorrecto: deben ser 3 o 4 letras seguidas de 6 dígitos",
                                }));
                              } else {
                                setErrors((prev) => ({ ...prev, rfc: "" }));
                              }
                            }}
                            onBlur={(e) => checkDuplicate("rfc", e.target.value)}
                            isInvalid={!!errors.rfc}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.rfc}
                        </Form.Control.Feedback>
                      </Form.Group>

                      {/* Teléfono del usuario */}
                      <Form.Group className="mb-3">
                        <Form.Label>Teléfono</Form.Label>
                        <Form.Control
                            type="tel"
                            placeholder="Ej. 5512345678"
                            value={formData.telefono}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              if (value.length <= 10) {
                                setFormData((prev) => ({ ...prev, telefono: value }));
                              }
                            }}
                            required
                        />
                        <Form.Text className="text-muted">Solo 10 dígitos sin espacios ni guiones.</Form.Text>
                      </Form.Group>

                      {/* Número Vendedor */}
                      <Form.Group controlId="numero_vendedor" className="mb-3">
                        <Form.Label>Número Vendedor</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Número Vendedor"
                            value={formData.numero_vendedor}
                            onChange={(e) => setFormData({ ...formData, numero_vendedor: e.target.value })}
                            required
                        />
                      </Form.Group>

                      {/* Plaza */}
                      {showPlaza && (
                          <Form.Group controlId="region_id" className="mb-3">
                            <Form.Label>Plaza</Form.Label>
                            <Dropdown show={showPlazaDropdown} onToggle={(open) => setShowPlazaDropdown(open)}>
                              <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start" id="dropdown-plaza">
                                {(() => {
                                  const sel = regiones.find(r => String(r.id) === String(formData.region_id));
                                  return sel?.plaza || uiPlazaLabel || "Seleccione plaza...";
                                })()}
                              </Dropdown.Toggle>

                              <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: 300, overflowY: "auto" }}>
                                <Form.Control
                                    autoFocus
                                    type="text"
                                    placeholder="Buscar plaza..."
                                    value={plazaSearch}
                                    onChange={(e) => setPlazaSearch(e.target.value.toUpperCase())}
                                    className="mb-2"
                                    style={{ textTransform: "uppercase" }}
                                />
                                {sortedPlazas
                                    .filter((p) => (p.plaza || "").toUpperCase().includes(plazaSearch))
                                    .map((p) => (
                                        <Dropdown.Item
                                            key={p.id}
                                            onClick={() => {
                                              setFormData((prev) => ({ ...prev, region_id: p.id }));
                                              setPlazaSearch("");
                                              setShowPlazaDropdown(false);
                                            }}
                                        >
                                          {p.plaza}
                                        </Dropdown.Item>
                                    ))}
                                {sortedPlazas.filter((p) => (p.plaza || "").toUpperCase().includes(plazaSearch)).length === 0 && (
                                    <div className="text-center text-muted py-2">Sin resultados</div>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                      )}

                      {/* Distribuidor — Dropdown dinámico */}
                      <Form.Group controlId="distribuidor_id" className="mb-3">
                        <Form.Label>Distribuidor</Form.Label>
                        <Dropdown show={showDistDropdown} onToggle={(open) => setShowDistDropdown(open)}>
                          <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start" id="dropdown-dist">
                            {(() => {
                              const sel = distList.find(d => String(d.id) === String(formData.distribuidor_id));
                              return sel?.nombre || uiDistLabel || "Seleccione distribuidor...";
                            })()}
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: 300, overflowY: "auto" }}>
                            <Form.Control
                                autoFocus
                                type="text"
                                placeholder="Buscar distribuidor..."
                                value={distSearch}
                                onChange={(e) => setDistSearch(e.target.value.toUpperCase())}
                                className="mb-2"
                                style={{ textTransform: "uppercase" }}
                            />
                            {sortedDistribuidores
                                .filter((d) => (d.nombre || "").toUpperCase().includes(distSearch))
                                .map((d) => (
                                    <Dropdown.Item
                                        key={d.id}
                                        onClick={() => {
                                          setFormData((prev) => ({ ...prev, distribuidor_id: d.id }));
                                          setDistSearch("");
                                          setShowDistDropdown(false);
                                        }}
                                    >
                                      {d.nombre}
                                    </Dropdown.Item>
                                ))}
                            {sortedDistribuidores.filter((d) => (d.nombre || "").toUpperCase().includes(distSearch)).length === 0 && (
                                <div className="text-center text-muted py-2">Sin resultados</div>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </Form.Group>

                      {/* Estado */}
                      <Form.Group controlId="Estado" className="mb-3">
                        <Form.Label>Estado</Form.Label>
                        <Form.Select
                            value={formData.Estado}
                            onChange={(e) => setFormData({ ...formData, Estado: e.target.value })}
                        >
                          <option value="Activo">Activo</option>
                          <option value="Inactivo">Inactivo</option>
                        </Form.Select>
                      </Form.Group>
                    </>
                )}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancelar
              </Button>
              <Button
                  variant="primary"
                  onClick={handleGuardar}
                  disabled={isRFCDuplicate || isBlacklisted}
              >
                Guardar
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal RFC duplicado/activo */}
          <Modal
              show={showDetailModal}
              onHide={() => setShowDetailModal(false)}
              size="lg"
              centered
              style={{ zIndex: 10000 }}
          >
            <Modal.Header closeButton>
              <Modal.Title>RFC Registrado</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <p>
                <strong>El RFC ya se encuentra registrado y activo.</strong>
                <br />
                Por favor revisa con tu supervisor de territorio.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                  variant="primary"
                  onClick={() => {
                    setShowDetailModal(false);
                  }}
              >
                Aceptar
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal Blacklist */}
          <Modal show={showBlacklistModal} onHide={() => setShowBlacklistModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Acceso Denegado</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <p>
                <strong>
                  Este asesor se encuentra en la lista negra.
                  <br />
                  Por favor revisa con tu supervisor de territorio.
                </strong>
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                  variant="primary"
                  onClick={() => {
                    setShowBlacklistModal(false);
                  }}
              >
                Aceptar
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </section>
  );
};

export default FormularioUsuarios;
